@let toggleButtonId = name() + '-toggle-button';

<button #toggleButtonElement (click)="toggleOptions()" [aria-expanded]="isSelectOpen()"
        [attr.aria-labelledby]="ariaLabelledBy() ? ariaLabelledBy() + ' ' + toggleButtonId : null"
        [attr.data-qa]="qaTag() + '-select-button'" [class.has-icon]="selectedOption()?.iconUrl || selectedOption()?.svgIcon" [disabled]="isDisabled()" [id]="toggleButtonId"
        class="button" type="button">
    @if (selectedOption()?.iconUrl) {
        <app-icon [iconUrl]="{url: selectedOption()?.iconUrl|authImage:{loadingElementSelf: true}, fallback: selectedOption()?.iconFallbackSvg }" aria-hidden="true" class="option-icon"/>
    } @else if (selectedOption()?.svgIcon) {
        <app-icon [svgIcon]="selectedOption()?.svgIcon" aria-hidden="true" class="option-icon"/>
    }
    <span class="option-label">{{ selectedOption()?.label }}</span>
    <app-icon [class.is-open]="isSelectOpen()" [svgIcon]="ICONS.NAVIGATE_NEXT" aria-hidden="true" class="option-icon option-icon-toggle"/>
</button>
@if (isSelectOpen()) {
    <div #optionGroupElement [attr.aria-labelledby]="ariaLabelledBy()" [attr.data-qa]="qaTag() + '-option-group'" [class.is-opening-upward]="isOpeningUpward()" class="option-group" role="radiogroup">
        @for (option of optionsList(); track option.value) {
            @let optionId = name() + '-' + option.value;

            <label [class.has-icon]="option.iconUrl || option.svgIcon" [for]="optionId" class="option">
                <input #inputElement
                       (click)="selectOption(option.value, $event)"
                       (keydown)="selectOption(option.value, $event)"
                       [attr.data-qa]="qaTag() + '-option-' + option.value"
                       [attr.name]="name()"
                       [checked]="option.isSelected"
                       [id]="optionId"
                       [value]="option.value"
                       class="option-input"
                       type="radio"/>
                @if (option.iconUrl) {
                    <app-icon [attr.data-qa]="qaTag() + '-option-icon-' + option.value" [iconUrl]="{url: option.iconUrl|authImage:{loadingElementSelf: true}, fallback: option.iconFallbackSvg }"
                              aria-hidden="true"
                              class="option-icon"/>
                } @else if (option.svgIcon) {
                    <app-icon [attr.data-qa]="qaTag() + '-option-icon-' + option.value" [svgIcon]="option.svgIcon" aria-hidden="true" class="option-icon"/>
                }
                <span [attr.data-qa]="qaTag() + '-option-label-' + option.value" class="option-label">{{ option.label }}</span>
                @if (option.isSelected) {
                    <app-icon [svgIcon]="ICONS.OK" aria-hidden="true" class="option-icon option-icon-selected"/>
                }
            </label>
        }
    </div>
}

